module.exports = __webpack_public_path__ + "img/slack.88357cc6.svg";